module.exports = __webpack_public_path__ + "img/667958ae66802877ffb45a6f566fc8d7.6c07d289.jpg";